<template>
  <b-col class="device-view panel">
    <b-row class="align-items-center">
      <b-col align-self="start" cols="3">
        <b-button class="btn-back p-0" variant="link" :to="{ name: 'VisnetHubFaultEventsPanel' }">
          <Icon name="back-arrow" />
        </b-button>
        <b-col>
          <h2 class="mb-0 pt-2">Fault Events</h2>
          <span class="attributes-list__label mb-0 pt-2">
            Phase {{ $route.params.phaseNumber }}
          </span>
          <span class="attributes-list__label mb-0 pt-2">
            Feeder {{ $route.params.feederNumber }}
          </span>
        </b-col>
      </b-col>
      <b-col offset="2">
        <b-form-group class="form-group__buttons">
          <label class="col-form-label pt-0">
            Event type
          </label>
          <v-select
            v-model="selectedEventType"
            :options="eventTypesSelectOptions"
            :searchable="false"
            placeholder="Select Event Type"
            class="custom-select"
            @change="filterEvents"
          >
            <template slot="selected-option" slot-scope="option">
              {{ option.label }}
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="align-items-center">
      <FaultTimespanPicker class="offset-5" :min-date="minDate" @changeTimespan="filterEvents" />
    </b-row>
    <PaginatedList
      :items="faultEvents"
      :set-page-callback="setPage"
      :per-page="perPage"
      :loading="$store.getters.activeLoaders('visnetHubFaultEvents')"
    >
      <template v-if="!!faultEvents.data && faultEvents.data.length" slot="items">
        <FaultEvent
          v-for="faultEvent in faultEvents.data"
          :key="faultEvent.id"
          v-bind="faultEvent"
        />
      </template>
      <template v-else slot="items"> No Data</template>
    </PaginatedList>
  </b-col>
</template>

<script>
import { mapState } from 'vuex';
import MomentTimezone from 'moment-timezone';
import DateMethods from '@/components/mixins/date-methods';
import { FORMAT_MS, START_OF_DAY, END_OF_DAY } from '@/components/shared/date-format';
import FaultEvent from '@/components/substations/visnet-hubs/main-view/fault/fault-event';
import FaultTimespanPicker from '@/components/substations/visnet-hubs/main-view/fault/fault-timespan-picker';
import PaginatedList from '@/components/shared/paginated-list';

const PER_PAGE = 5; // should never be lower than paginated totalCount/totalPages
const PAGINATION_PARAMS = { number: 1, size: PER_PAGE };
const EVENT_TYPES_SELECT_OPTIONS = [{ event: 'current_voltage_wave', label: 'All' }];

export default {
  name: 'VisnetHubEventsList',
  components: { FaultEvent, PaginatedList, FaultTimespanPicker },
  mixins: [DateMethods],
  props: { minDate: Date },
  data() {
    return {
      selectedEventType: EVENT_TYPES_SELECT_OPTIONS[0],
      perPage: PER_PAGE,
      eventTypesSelectOptions: EVENT_TYPES_SELECT_OPTIONS,
      payload: { q: {} }
    };
  },
  computed: mapState({
    faultEvents: state => state.visnetHubFaultEvents
  }),
  destroyed() {
    this.$store.commit('visnetHubFaultEvents/resetStore');
  },
  methods: {
    setPage(newValue) {
      this.getPage({ page: { number: newValue, size: PER_PAGE }, ...this.payload });
    },
    getPage(options = {}) {
      const {
        projectCode,
        substationCode,
        externalVisnetHubId,
        phaseNumber,
        feederNumber
      } = this.$route.params;

      this.$store.dispatch(
        'visnetHubFaultEvents/fetchPage',
        Object.assign(
          {},
          {
            options: { externalVisnetHubId },
            phaseNumber,
            feederNumber,
            projectCode,
            substationCode
          },
          options
        )
      );
    },
    filterEvents(value) {
      switch (true) {
        case !value:
          this.payload = {
            q: {},
            data_type: [EVENT_TYPES_SELECT_OPTIONS[0]]
          };

          break;
        case !!value.event:
          this.payload = { ...this.payload, data_type: [value.event] };

          break;
        case !!value.label:
          this.payload = {
            q: {},
            data_type: [EVENT_TYPES_SELECT_OPTIONS[0]]
          };

          break;
        case !!value.selectedDate:
          this.generateTimestamps(value);

          break;
        default:
          break;
      }
      this.getPage({ page: PAGINATION_PARAMS, ...this.payload });
    },
    generateTimestamps({ selectedTime, selectedDate }) {
      let timestampStart;
      let timestampEnd;

      const { start: startDate, end: endDate } = selectedDate;
      const { startTime = START_OF_DAY, endTime = END_OF_DAY } = selectedTime || {};

      const { hours: startTimeHours, minutes: startTimeMinutes } = this.splitHoursMinutes(
        startTime
      );
      const { hours: endTimeHours, minutes: endTimeMinutes } = this.splitHoursMinutes(endTime);

      if (startDate && endDate) {
        const startOfASelectedDay = `${this.YMDToString(startDate)} ${START_OF_DAY}`;
        const endOfASelectedDay = `${this.YMDToString(endDate)} ${START_OF_DAY}`;

        timestampStart = MomentTimezone(startOfASelectedDay)
          .add(startTimeHours, 'H')
          .add(startTimeMinutes, 'm')
          .format(FORMAT_MS);

        timestampEnd = MomentTimezone(endOfASelectedDay)
          .add(endTimeHours, 'H')
          .add(endTimeMinutes, 'm')
          .format(FORMAT_MS);
      }

      this.payload.q.timestamp_gte = timestampStart;
      this.payload.q.timestamp_lte = timestampEnd;
    }
  }
};
</script>
